const APPLE_SCRIPT_URL =
  "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

let appleScriptPromise;

export function loadAppleSignInScript() {
  if (window.AppleID?.auth) return Promise.resolve();
  if (appleScriptPromise) return appleScriptPromise;

  appleScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(`script[src="${APPLE_SCRIPT_URL}"]`);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", () => reject(new Error("Apple Sign-In could not be loaded.")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = APPLE_SCRIPT_URL;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Apple Sign-In could not be loaded."));
    document.head.appendChild(script);
  }).then(() => {
    if (!window.AppleID?.auth) {
      throw new Error("Apple Sign-In is unavailable.");
    }
  });

  return appleScriptPromise;
}

export function configureAppleSignIn({ state, nonce, usePopup = false }) {
  if (!window.AppleID?.auth) {
    throw new Error("Apple Sign-In is unavailable.");
  }

  window.AppleID.auth.init({
    clientId: "com.yolleg.CodeGenWeb",
    redirectURI: "https://developer-ai.com/devaix/dev_ai_login/apple-signin-web",
    scope: "name email",
    state,
    nonce,
    usePopup,
  });
}
